var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveTrackerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Live tracker"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.8 19H17.2C17.6774 19 18.1352 18.8104 18.4728 18.4728C18.8104 18.1352 19 17.6774 19 17.2V2.8C19 2.32261 18.8104 1.86477 18.4728 1.52721C18.1352 1.18964 17.6774 1 17.2 1H6.4C5.92261 1 5.46477 1.18964 5.12721 1.52721C4.78964 1.86477 4.6 2.32261 4.6 2.8V17.2C4.6 17.6774 4.41036 18.1352 4.07279 18.4728C3.73523 18.8104 3.27739 19 2.8 19ZM2.8 19C2.32261 19 1.86477 18.8104 1.52721 18.4728C1.18964 18.1352 1 17.6774 1 17.2V9.1C1 8.11 1.81 7.3 2.8 7.3H4.6",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4 11.8H8.19995",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.7 15.4H8.19995",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.19995 4.60001H15.4V8.20001H8.19995V4.60001Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTrackerIcon);
export default __webpack_public_path__ + "static/media/LiveTrackerIcon.072264b8dd93170ba2c4f15b4aad4921.svg";
export { ForwardRef as ReactComponent };